// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

// Va Engine controllers

import AlertController from "@va/controllers/alert_controller"
application.register("alert", AlertController)

import AutoSubmitController from "@va/controllers/auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AutoclickController from "@va/controllers/autoclick_controller"
application.register("autoclick", AutoclickController)

import CheckboxesGroupController from "@va/controllers/checkboxes_group_controller"
application.register("checkboxes-group", CheckboxesGroupController)

import ClipboardController from "@va/controllers/clipboard_controller.js"
application.register("clipboard", ClipboardController)

import DropdownController from "@va/controllers/dropdown_controller"
application.register("dropdown", DropdownController)

import FileUploadController from "@va/controllers/file_upload_controller"
application.register("file-upload", FileUploadController)

import NavbarController from "@va/controllers/navbar_controller"
application.register("navbar", NavbarController)

import TextareaGrowController from "@va/controllers/textarea_grow_controller"
application.register("textarea-grow", TextareaGrowController)

import RangeValueController from "@va/controllers/range_value_controller"
application.register("range-value", RangeValueController)

import ConditionalDisplayController from "@va/controllers/conditional_display_controller"
application.register("conditional-display", ConditionalDisplayController)

import InputValidationController from "@va/controllers/input_validation_controller"
application.register("input-validation", InputValidationController)

import ClipboardControllerController from "@va/controllers/clipboard_controller"
application.register("clipboard", ClipboardControllerController)

import FilterDropdownControllerController from "@va/controllers/filter_dropdown_controller"
application.register("filter-dropdown", FilterDropdownControllerController)

import FilterParentController from "@va/controllers/filter_parent_controller"
application.register("filter-parent", FilterParentController)

import FilterPresetController from "@va/controllers/filter_preset_controller"
application.register("filter-preset", FilterPresetController)

import FilterColumnsController from "@va/controllers/filter_columns_controller"
application.register("filter-columns", FilterColumnsController)

import AutoRedirectController from "./auto_redirect_controller"
application.register("auto-redirect", AutoRedirectController)

import DeletionPollController from "./deletion_poll_controller"
application.register("deletion-poll", DeletionPollController)

import ScheduleFormController from "./schedule_form_controller"
application.register("schedule-form", ScheduleFormController)

